





































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
const cssPrefix = 'releaseType';

@Component({
  components: {
    ...UUIFComponents,
    SwIcon,
  },
})

export default class ReleasetypeModal extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  showReleaseTypeDialog: boolean;
  created() {
    console.warn('created');
  }
  closeDialog() {
    this.$emit('closeDialog');
  }
}
